import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default class IndexRoute extends Route {
  model() {
    return {
      dispos: {
        contacts: [],
        products: [],
      },
    };
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    set(controller, 'bookConfirmed', null);
    set(controller, 'showMenu', null);
    set(controller, 'people', []);
    set(controller, 'waitListNotes', null);
    set(controller, 'hidePartecipoIo', false);
    set(controller, 'add_younger', false);
    set(controller, 'dateCalendar', new Date());
  }
}
